export default "__VITE_ASSET__acc64cbf__"